import { Box } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { FormEndowment } from './FormEndowment'
import { UnitCS } from './UnitCS'

export const EndowmentModalContent = ({data, onClose, fromRoutes=false}) => {
  // debugger
  const [handleData, setHandleData] = useState({})

  useEffect(() => {
    if(fromRoutes && data.type === 'PORTATIL'){
      const { cil10, cil20, cil30, cil45, id, unit, station, type } = data
      setHandleData({
        cil10, cil20, cil30, cil45,
        idUnit: id, 
        quantity: cil10 + cil20 + cil30 + cil45,
        unit, station, type
      })
    } else {
      setHandleData(data)
    }
    // eslint-disable-next-line
  }, [])
  return (
    <Box>
      <UnitCS data={handleData}/>
      <FormEndowment onClose={onClose} data={handleData}/>
    </Box>
  )
}
